import {Badge, Icon, Tooltip} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface ProtectedRoleBadgeProps {
  roleKey: string;
}

/** Renders a Sollapay-assigned role (e.g. `firm_support`) as a locked, non-interactive chip — never the role select. */
export const ProtectedRoleBadge: FC<ProtectedRoleBadgeProps> = ({roleKey}) => {
  const {t} = useTranslation(['team', 'common']);

  return (
    <Tooltip content={t('team:systemAccessGroup.roleTooltip')}>
      <Badge variant="neutral" size="md">
        <Icon name="lock" className="size-3" />
        {t(`common:roles.${roleKey}`)}
      </Badge>
    </Tooltip>
  );
};
